<template>
<span>
    <el-input type="text" name="orderCode" clearable size="small" placeholder="请输入订单编号" :value="value" @input="$emit('input', $event)" >
        <i slot="suffix" class="el-input__icon el-icon-document-copy" @click="openBatchInputCode"></i>
    </el-input>
    <el-dialog title="批量输入订单编号" :visible.sync="visible" width="500">
        <el-input type="textarea" :rows="15" v-model="batchInputCode" placeholder="多个用空格、换行、逗号分隔，支持复制粘贴Excel单元格">

        </el-input>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleBatchInputCode">确定</el-button>
        </div>
    </el-dialog>
</span>
</template>

<script>
export default {
    name: 'XmBatchInput',
    data() {
        return {
            visible: false,
            batchInputCode: ''
        }
    },
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    methods: {
        openBatchInputCode(){
            this.batchInputCode = this.value;
            this.visible = true;
        },
        handleBatchInputCode(){
            let codes = this.batchInputCode.split(/[\s,，\n]+/).filter(code => code.trim());
            this.$emit('input', codes.join(','));
            this.visible = false;
        }
    }
}
</script>